import { NavLink } from 'react-router-dom';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faKey } from '@fortawesome/free-solid-svg-icons';
import { Box, Flex } from 'components/layout';
import { Logo } from 'components/Logo';
import { useAuth } from 'context/UserAuthContext';

export const Header = () => {
  const { loggedIn } = useAuth()
  const link = loggedIn ? '/' : '/login';
  const { logoutUser } = useAuth();

  const handleClick = (e) => {
    console.log("handleClick", loggedIn);
    if(loggedIn) {
//      e.preventDefault();
      logoutUser();
    }
  };

  return (
    <HBox>
      <Logo to={null} />
      <Box $ml={'auto'} $pr={10} $mt={'auto'}>
        <Link to={link} onClick={handleClick}>
          <FAIcon icon={faKey}/>{loggedIn ? 'Sign Out' : 'Sign In' }
        </Link>
      </Box>
    </HBox>
  )
}

const FAIcon = styled(FontAwesomeIcon)`
  margin: 0 5px;
`;

const HBox = styled(Flex)`
  flex: 1 0 auto;
  border-bottom: 1px solid var(--color-border-default);
  padding-bottom: 10px;
`;

const Link = styled(NavLink)`
  text-decoration: none;
`;
